/* eslint-disable import/no-unresolved */
import ReportConfigDetails from 'views/Rules/common/ReportConfigDetails';

const FFIEC009ReportConfigDetails = ({
    selectedFFIEC009Quarter, setSelectedFFIEC009Quarter, summaryQuartersFFIEC009Data, commonFFIEC009Data,
}) => (
    <ReportConfigDetails
        selectedQuarter={selectedFFIEC009Quarter}
        setSelectedQuarter={setSelectedFFIEC009Quarter}
        summaryQuartersData={summaryQuartersFFIEC009Data}
        commonData={commonFFIEC009Data}
        displayColumn="Yes"
        istopier="No"
        rule="FFIEC009"
    />
);

export default FFIEC009ReportConfigDetails;
